import * as React from 'react'
import { Icon } from '../../components/UI/Icon'
import {
  StyledOptionalNote,
  StyledTable,
  StyledTableAsideCell,
  StyledTableBodyCell,
  StyledTableCellCategoryNameCell,
  StyledTableHeaderCell,
  StyledTableInner,
  StyledTableWrapper,
  StyledWrapper,
} from './styled'
import CustomLink from '../../components/CustomLink'
import { useI18n } from '../../lib/context/i18n'
import { sbEditable } from '@storyblok/storyblok-editable'

export const FeaturesTable = ({ blok }) => {
  const columns = blok.productTypes.length
  const { getTranslatedUrlFromLink } = useI18n()

  return (
    <StyledWrapper {...sbEditable(blok)}>
      <h2>{blok.headline}</h2>
      <StyledTableWrapper>
        <StyledTableInner>
          <StyledTable columns={columns}>
            <StyledTableAsideCell></StyledTableAsideCell>
            {blok.productTypes.map(productType => {
              return <StyledTableHeaderCell key={productType._uid}>{productType.name}</StyledTableHeaderCell>
            })}
            {blok.categoryGroups.map(categoryGroup => {
              return (
                <React.Fragment key={categoryGroup._uid}>
                  <StyledTableCellCategoryNameCell columns={columns}>
                    <h3>{categoryGroup.name}</h3>
                  </StyledTableCellCategoryNameCell>
                  {blok.productTypes.map(productType => (
                    <div key={productType._uid}></div>
                  ))}
                  {categoryGroup.properties.map(property => {
                    return (
                      <React.Fragment key={property._uid}>
                        <StyledTableAsideCell>
                          {property.link?.cached_url ? (
                            <CustomLink
                              to={getTranslatedUrlFromLink(property.link)}
                              target={property.link.linktype === 'url' ? '_blank' : '_self'}
                            >
                              {property.name}
                            </CustomLink>
                          ) : (
                            property.name
                          )}
                        </StyledTableAsideCell>
                        {property.availabilities.map(availability => {
                          return (
                            <StyledTableBodyCell key={availability._uid} isAvalible={availability.avalible}>
                              <Icon name={availability.avalible ? 'check' : 'minus'} />
                              {availability.optionalNote && (
                                <StyledOptionalNote>{availability.optionalNote}</StyledOptionalNote>
                              )}
                            </StyledTableBodyCell>
                          )
                        })}
                      </React.Fragment>
                    )
                  })}
                </React.Fragment>
              )
            })}
          </StyledTable>
        </StyledTableInner>
      </StyledTableWrapper>
    </StyledWrapper>
  )
}
